module.exports = __webpack_public_path__ + "img/paypal.2ab10d4c.svg";